import { ProductsUser } from "../customTypes/ProductsUser";
import { KAMSProductUrlQueryParams, ProductUrlQueryParams } from "../urls";

export default function getTenantIdByUserType(
  productsUser: ProductsUser,
  userType,
  params: KAMSProductUrlQueryParams | ProductUrlQueryParams
): string {
  if (productsUser.isKAMS && "tenant" in params) {
    const tenantId = params.tenant;
    return tenantId;
  } else {
    const tenantIdFromUserAccess = userType?.accesses[0]?.objectId;
    return tenantIdFromUserAccess;
  }
}
